import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { INDICATOR_LABEL_TRANSLATIONS, IndicatorLabelTranslations } from '@hdms/shared/ui-core';

export const INDICATOR_LABEL_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: INDICATOR_LABEL_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): IndicatorLabelTranslations => ({
    ultimate: i18NextService.t('common.label.performance.ultimate'),
    premium: i18NextService.t('common.label.performance.premium'),
    standard: i18NextService.t('common.label.performance.standard')
  })
};
